import { render, staticRenderFns } from "./cardUnitView.vue?vue&type=template&id=282c87e2"
import script from "./cardUnitView.vue?vue&type=script&lang=js"
export * from "./cardUnitView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports